import React from "react";
import Image from "Shared/ImageFallback";
import * as styles from "./base.scss";
export default class RawDescription extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.base },
            React.createElement("div", { className: styles.h3 }, this.props.title),
            !!this.props.imageUrls && this.props.imageUrls.length > 0 && (React.createElement(Image, { src: this.props.imageUrls[0], size: "tiny" })),
            React.createElement("div", { className: styles.wrapper, dangerouslySetInnerHTML: { __html: this.props.content } }),
            !!this.props.cuttingDetail &&
                !!this.props.animalType &&
                this.props.animalType === "N" && (React.createElement("div", { className: styles.cuttingDetail },
                React.createElement("a", { href: "/styles/images/styckningsschema-notkott.jpg" },
                    React.createElement("img", { width: "300", alt: "Styckningsschema n\u00F6tk\u00F6tt", src: "/styles/images/styckningsschema-notkott.jpg" }))))));
    }
}
